var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "fieldset",
      {
        staticClass: "date-input-fieldset",
        attrs: {
          "aria-label": _vm.legendText,
          "aria-describedby": _vm.inputId,
          "aria-live": "polite",
        },
      },
      [
        _c("KTextBox", {
          ref: _vm.inputRef,
          attrs: {
            value: _vm.value,
            type: "date",
            pattern: "\\d{4}-\\d{2}-\\d{2}",
            label: _vm.legendText,
            autoComplete: "off",
            invalid: Boolean(_vm.errorMessage),
            showInvalidText: Boolean(_vm.errorMessage),
            invalidText: _vm.errorMessage,
            floatingLabel: false,
          },
          on: { input: _vm.handleInput },
        }),
        _c("span", { staticClass: "k-date-vhidden" }, [
          _vm.value
            ? _c("span", { attrs: { id: _vm.inputId } }, [
                _vm._v("\n        " + _vm._s(_vm.dateDescription) + "\n      "),
              ])
            : _vm._e(),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }